// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";

const addressValidationUrl = "/api/guest/addressvalidation";

export interface AddressValidationModel {
    address1: string;
    address2: string;
    city: string;
    stateProvince: string;
    country: string;
    phone: string;
    postalCode: string;
    contact: string;
}

export interface AddressValidationCandidate {
    isCassCertified?: boolean;
    isResComValid?: boolean;
    isValidated?: boolean;
    residential?: boolean;
    taxIdType?: string;
    address1: string;
    address2: string;
    city: string;
    stateProvince: string;
    country: string;
    phone: string;
    postalCode: string;
    contact: string;
}

export interface AddressValidationResultModel {
    errorCode: number;
    errorMessage: string;
    candidates: AddressValidationCandidate[] | null;
}

export async function addressValidationService(
    parameter: AddressValidationModel,
): Promise<ServiceResult<AddressValidationResultModel>> {
    try {
        const addressValidationResult = await post<any>(`${addressValidationUrl}`, parameter);
        return {
            result: addressValidationResult,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: (error as any)?.errorJson?.errorMessage,
        };
    }
}
